import { DepartmentDetails } from "@/interfaces/departmentDetails";

const hostUrl = process.env.NEXT_PUBLIC_HOST_URL ?? "";

const parisDepartmentSlug = "75";
const parisCityPath = "v/paris-75056";

export const DepartmentLink = ({ slug, name }: DepartmentDetails) => {
  let path = `departement/${slug}`;
  if (slug === parisDepartmentSlug) {
    path = parisCityPath;
  }

  return <a href={`${hostUrl}/agences/${path}`}>{name}</a>;
};
